const newInspection = {
  buttons: {
    backbtn: "Atrás",
    submit: "Enviar",
    ok: "Aceptar",
    cancel: "Cancelar",
    yes: "Si",
    no: "No, solo la inspeccion"
  },
  messages: {
    addTask: "¿Desea agregar una tarea?"
  }
};
export default newInspection;
